/*
 * Relógio da lista VIP do Burst Sleep: contagem regressiva até a abertura das vendas, em dígitos de LED
 * desenhados em SVG (sem arquivo de fonte). A parte pura é exportada para os testes em Node; a parte de
 * tela (iniciar) roda só no navegador. Quando a contagem acaba, o relógio some e o formulário continua.
 */
(function (raiz, fabrica) {
  var api = fabrica(raiz);
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    raiz.BstContagem = api;
  }
})(typeof self !== 'undefined' ? self : this, function (raiz) {
  'use strict';

  // Segmentos acesos de 0 a 9 (a = topo, depois no sentido horário; g = meio).
  var SEGMENTOS = ['abcdef', 'bc', 'abdeg', 'abcdg', 'bcfg', 'acdfg', 'acdefg', 'abc', 'abcdefg', 'abcdfg'];
  var SEM_FUSO = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/;
  var COM_FUSO = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})$/;

  /* ---------- parte pura ---------- */

  // "2026-10-23T08:00:00-03:00" vira milissegundos. Sem fuso, vale a hora de Brasília (quem edita o
  // tema pensa na hora daqui; o visitante pode estar em outro fuso). Qualquer outro formato: NaN.
  function lerAlvo(texto) {
    var t = String(texto == null ? '' : texto).trim();
    if (SEM_FUSO.test(t)) t += (t.length === 16 ? ':00' : '') + '-03:00';
    if (!COM_FUSO.test(t)) return NaN;
    return Date.parse(t);
  }

  // Arredonda o segundo quebrado para cima: o visor só mostra 00:00:00:00 no instante do alvo.
  function partes(alvo, agora) {
    if (!isFinite(alvo) || !isFinite(agora)) return null;
    var resto = Math.ceil((alvo - agora) / 1000);
    if (resto <= 0) return { dias: 0, horas: 0, minutos: 0, segundos: 0, acabou: true };
    return {
      dias: Math.min(Math.floor(resto / 86400), 99),
      horas: Math.floor((resto % 86400) / 3600),
      minutos: Math.floor((resto % 3600) / 60),
      segundos: resto % 60,
      acabou: false
    };
  }

  function segmentos(n) {
    return SEGMENTOS[n] || '';
  }

  function algarismos(p) {
    var lista = [];
    [p.dias, p.horas, p.minutos, p.segundos].forEach(function (valor) {
      var n = Math.max(0, Math.min(99, Math.floor(valor)));
      lista.push(Math.floor(n / 10), n % 10);
    });
    return lista;
  }

  function unidade(n, singular, plural) {
    return n + ' ' + (n === 1 ? singular : plural);
  }

  // Para leitor de tela: muda uma vez por minuto (os segundos ficam de fora de propósito).
  function frase(p) {
    var itens = [];
    if (p.dias) itens.push(unidade(p.dias, 'dia', 'dias'));
    if (p.horas) itens.push(unidade(p.horas, 'hora', 'horas'));
    if (p.minutos) itens.push(unidade(p.minutos, 'minuto', 'minutos'));
    if (!itens.length) return 'Falta menos de 1 minuto';
    var texto = itens.length === 1 ? itens[0] : itens.slice(0, -1).join(', ') + ' e ' + itens[itens.length - 1];
    return ((p.dias || p.horas || p.minutos) === 1 ? 'Falta ' : 'Faltam ') + texto;
  }

  /* ---------- tela ---------- */

  function iniciar(caixa) {
    if (!caixa || caixa.getAttribute('data-bst-pronto') === '1') return;
    var alvo = lerAlvo(caixa.getAttribute('data-alvo'));
    var digitos = caixa.querySelectorAll('[data-bst-digito]');
    var leitor = caixa.querySelector('[data-bst-contagem-frase]');
    if (isNaN(alvo) || digitos.length !== 8) {
      caixa.hidden = true;
      return;
    }
    caixa.setAttribute('data-bst-pronto', '1');
    var ultimaFrase = '';

    function desenhar() {
      var agora = Date.now();
      var p = partes(alvo, agora);
      if (!p || p.acabou) {
        caixa.hidden = true;
        return;
      }
      algarismos(p).forEach(function (n, i) {
        var acesos = segmentos(n);
        var tracos = digitos[i].querySelectorAll('[data-s]');
        for (var j = 0; j < tracos.length; j++) {
          tracos[j].setAttribute('class', acesos.indexOf(tracos[j].getAttribute('data-s')) >= 0 ? 'is-aceso' : '');
        }
      });
      var f = frase(p);
      if (leitor && f !== ultimaFrase) {
        leitor.textContent = f;
        ultimaFrase = f;
      }
      // próxima troca exatamente quando o segundo vira (mesmo arredondamento de partes)
      setTimeout(desenhar, ((alvo - agora) % 1000 || 1000) + 5);
    }
    desenhar();
  }

  if (typeof document !== 'undefined' && document.querySelectorAll) {
    var iniciarTudo = function () {
      Array.prototype.forEach.call(document.querySelectorAll('[data-bst-contagem]'), iniciar);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciarTudo);
    else iniciarTudo();
  }

  return {
    lerAlvo: lerAlvo,
    partes: partes,
    segmentos: segmentos,
    algarismos: algarismos,
    frase: frase,
    iniciar: iniciar
  };
});
